/* CsakCsajok keresés + oldalátmenet – a sections/cc-search.liquid-ból kiemelve (2026-10-21 perf2, defer). Leírás: a szekció fejkommentje. */
(() => {
  'use strict';
  if (window.__ccs) return;
  window.__ccs = true;

  /* ------------------------------------------------------------ beállítások */
  const cfgEl = document.querySelector('[data-ccs-config]');
  let userCfg = {};
  try { userCfg = JSON.parse((cfgEl && cfgEl.getAttribute('data-ccs-config')) || '{}'); } catch (e) { userCfg = {}; }
  const CFG = Object.assign({ popular: [], menu: [], placeholder: 'Mit keresel? Pl. léghullámos, gésagolyó…', placeholder_m: 'Mit keresel?', limit: 8 }, userCfg);
  const SEARCH_URL = '/search';

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const mqDesk = window.matchMedia('(min-width: 900px)');
  const nf = new Intl.NumberFormat('hu-HU');
  const norm = (s) => (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
  // mobilon rövid placeholder: a hosszú példás szöveg keskeny mezőben levágódik (a példák a „Népszerű keresések” közt úgyis ott vannak)
  const placeholder = () => (mqDesk.matches ? CFG.placeholder : (CFG.placeholder_m || CFG.placeholder));

  const IC_SEARCH = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>';
  const IC_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';
  const IC_DOC = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 3h9l4 4v14H6z"/><path d="M14 3v5h5M9 13h7M9 17h5"/></svg>';
  const IC_CLOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';

  /* ------------------------------------------------------------ előzmények */
  const RKEY = 'ccs_recent';
  const recent = {
    get() { try { return JSON.parse(localStorage.getItem(RKEY) || '[]').filter(Boolean).slice(0, 6); } catch (e) { return []; } },
    add(q) { q = (q || '').trim(); if (q.length < 2) return; try { const a = recent.get().filter((x) => norm(x) !== norm(q)); a.unshift(q); localStorage.setItem(RKEY, JSON.stringify(a.slice(0, 6))); } catch (e) { /* nincs tárhely */ } },
    clear() { try { localStorage.removeItem(RKEY); } catch (e) { /* nincs tárhely */ } }
  };

  /* ------------------------------------------------------------ adatok */
  const cache = new Map();
  function api(q, signal) {
    const key = norm(q);
    if (cache.has(key)) return Promise.resolve(cache.get(key));
    const p = new URLSearchParams();
    p.set('q', q);
    p.set('resources[type]', 'product,collection,article,query');
    p.set('resources[limit]', String(CFG.limit));
    p.set('resources[limit_scope]', 'each');
    p.set('resources[options][unavailable_products]', 'last');
    p.set('resources[options][fields]', 'title,product_type,variants.title,vendor,tag');
    const getResults = (params) => fetch('/search/suggest.json?' + params.toString(), { signal, headers: { Accept: 'application/json' } })
      .then((r) => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then((j) => (j.resources && j.resources.results) || {});
    return getResults(p).then(async (res) => {
      const tokens = key.split(/\s+/).filter(Boolean);
      const score = (product) => {
        const title = norm(product.title);
        return title === key ? 3 : tokens.every((token) => title.includes(token)) ? 2 : 0;
      };
      let products = res.products || [];
      // Ha a rövid név kimaradt, a Shopify teljes nevet tartalmazó javaslatával pontosítunk.
      if (key.length >= 3 && !products.some((product) => score(product) > 0)) {
        const suggestion = (res.queries || []).find((item) =>
          norm(item.text) !== key && (' ' + norm(item.text) + ' ').includes(' ' + key + ' '));
        if (suggestion) {
          const exactParams = new URLSearchParams(p);
          exactParams.set('q', suggestion.text);
          const exact = await getResults(exactParams).catch((e) => {
            if (e.name === 'AbortError') throw e;
            return {};
          });
          products = [...(exact.products || []).filter((product) => score(product) > 0), ...products];
        }
      }
      const seen = new Set();
      res.products = products.filter((product) => {
        const id = product.id || product.url;
        if (seen.has(id)) return false;
        seen.add(id); return true;
      }).sort((a, b) => score(b) - score(a)).slice(0, CFG.limit);
      cache.set(key, res); return res;
    });
  }

  let colsP = null;
  function loadCols() {
    if (!colsP) {
      colsP = fetch('/collections.json?limit=250', { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : { collections: [] }))
        .then((j) => (j.collections || []).filter((c) => c.products_count > 0).map((c) => ({ t: c.title, u: '/collections/' + c.handle, n: norm(c.title), img: c.image && c.image.src, c: c.products_count })))
        .catch(() => []);
    }
    return colsP;
  }
  function lev(a, b) {
    const m = a.length; const n = b.length;
    if (Math.abs(m - n) > 1) return 2;
    const d = Array.from({ length: m + 1 }, (_, i) => [i]);
    for (let j = 1; j <= n; j++) d[0][j] = j;
    for (let i = 1; i <= m; i++) for (let j = 1; j <= n; j++) d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
    return d[m][n];
  }
  const ALIAS = { dugo: 'plug', analdugo: 'plug', dugok: 'plug', gyongy: 'gyongysor', tojas: 'vibracios', bugyi: 'vibracios' };
  function matchCols(q, idx) {
    const toks = norm(q).split(/\s+/).filter(Boolean).map((t) => ALIAS[t] || t);
    if (!toks.length) return [];
    const out = [];
    idx.forEach((c) => {
      const words = c.n.split(/[^a-z0-9]+/).filter(Boolean);
      let score = 0;
      for (const t of toks) {
        let best = 0;
        for (const w of words) {
          if (w === t) best = Math.max(best, 4);
          else if (w.startsWith(t)) best = Math.max(best, 3);
          else if (t.length >= 3 && w.includes(t)) best = Math.max(best, 2);
          else if (t.length >= 5 && lev(w, t) <= 1) best = Math.max(best, 1);
        }
        if (!best) { score = 0; break; }
        score += best;
      }
      if (score) out.push({ c, score });
    });
    out.sort((a, b) => b.score - a.score || b.c.c - a.c.c);
    return out.slice(0, 6).map((x) => x.c);
  }

  /* ------------------------------------------------------------ megjelenítés */
  function highlight(text, q) {
    const terms = norm(q).split(/\s+/).filter((t) => t.length > 0);
    const plain = String(text);
    if (!terms.length) return esc(plain);
    let stripped = '';
    const map = [];
    for (let i = 0; i < plain.length; i++) {
      const s = plain[i].normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
      for (let k = 0; k < s.length; k++) { stripped += s[k]; map.push(i); }
    }
    const marks = new Array(plain.length).fill(false);
    terms.forEach((t) => {
      let from = 0;
      for (;;) {
        const at = stripped.indexOf(t, from);
        if (at < 0) break;
        for (let k = at; k < at + t.length; k++) marks[map[k]] = true;
        from = at + t.length;
      }
    });
    let out = ''; let on = false;
    for (let i = 0; i < plain.length; i++) {
      if (marks[i] && !on) { out += '<mark class="ccs-mark">'; on = true; }
      if (!marks[i] && on) { out += '</mark>'; on = false; }
      out += esc(plain[i]);
    }
    return out + (on ? '</mark>' : '');
  }
  const money = (v) => { const n = parseFloat(v); return isNaN(n) ? '' : nf.format(Math.round(n)) + ' Ft'; };

  function productHtml(p, q) {
    const img = p.featured_image && p.featured_image.url ? p.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2') : '';
    const cmp = parseFloat(p.compare_at_price_max);
    const price = parseFloat(p.price);
    const sale = !isNaN(cmp) && !isNaN(price) && cmp > price;
    return '<a class="ccs-prod ccs-it" href="' + esc(p.url) + '" role="option">' +
      '<span class="ccs-pimg">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="64" height="64">' : '') + '</span>' +
      '<span><span class="ccs-pt">' + highlight(p.title, q) + '</span>' +
      '<span class="ccs-pm">' + (p.available === false ? '<span class="ccs-tag">Elfogyott</span>' : '') + '<b>' + money(p.price) + '</b>' + (sale ? '<s>' + money(p.compare_at_price_max) + '</s>' : '') + (p.vendor ? '<span>' + esc(p.vendor) + '</span>' : '') + '</span></span></a>';
  }

  function renderResults(res, cols, q) {
    let html = '';
    const seen = new Set();
    const catList = [];
    const seenT = new Set();
    cols.forEach((c) => { if (!seen.has(c.u) && !seenT.has(norm(c.t))) { seen.add(c.u); seenT.add(norm(c.t)); catList.push({ t: c.t, u: c.u, img: c.img }); } });
    (res.collections || []).forEach((c) => { if (!seen.has(c.url) && !seenT.has(norm(c.title))) { seen.add(c.url); seenT.add(norm(c.title)); catList.push({ t: c.title, u: c.url }); } });
    if (catList.length) {
      html += '<div class="ccs-sec"><p class="ccs-h">Kategóriák</p><div class="ccs-chips">' +
        catList.slice(0, 6).map((c) => '<a class="ccs-chip ccs-it" role="option" href="' + esc(c.u) + '">' + (c.img ? '<img src="' + esc(c.img.replace(/(\.[a-z]+)(\?|$)/i, '_60x60$1$2')) + '" alt="" loading="lazy">' : '') + '<span class="ccs-ct">' + highlight(c.t, q) + '</span></a>').join('') + '</div></div>';
    }
    const prods = res.products || [];
    if (prods.length) {
      html += '<div class="ccs-sec"><p class="ccs-h">Termékek</p><div class="ccs-prods">' + prods.map((p) => productHtml(p, q)).join('') + '</div></div>';
    }
    const arts = res.articles || [];
    if (arts.length) {
      html += '<div class="ccs-sec"><p class="ccs-h">Útmutatók</p><div class="ccs-arts">' + arts.slice(0, 3).map((a) => '<a class="ccs-art ccs-it" role="option" href="' + esc(a.url) + '">' + IC_DOC + '<span>' + highlight(a.title, q) + '</span></a>').join('') + '</div></div>';
    }
    const qs = (res.queries || []).map((x) => x.text).filter((t) => norm(t) !== norm(q)).slice(0, 5);
    if (qs.length) {
      html += '<div class="ccs-sec"><p class="ccs-h">Erre is kereshetsz</p><div class="ccs-chips">' + qs.map((t) => '<button type="button" class="ccs-chip ccs-it" role="option" data-q="' + esc(t) + '">' + IC_SEARCH.replace('<svg', '<svg width="14" height="14"') + esc(t) + '</button>').join('') + '</div></div>';
    }
    if (!catList.length && !prods.length && !arts.length) {
      html += '<div class="ccs-empty"><b>Erre nem találtunk semmit 🙈</b>Próbáld másképp írni, vagy válassz az alábbiak közül.</div>' + suggestHtml(false);
    }
    return html;
  }

  function suggestHtml(withRecent) {
    let html = '';
    const rec = withRecent ? recent.get() : [];
    if (rec.length) {
      html += '<div class="ccs-sec"><p class="ccs-h">Legutóbbi keresések <button type="button" data-clear-recent>Törlés</button></p><div class="ccs-chips">' +
        rec.map((t) => '<button type="button" class="ccs-chip ccs-chip--hist ccs-it" role="option" data-q="' + esc(t) + '">' + IC_CLOCK + esc(t) + '</button>').join('') + '</div></div>';
    }
    if (CFG.popular.length) {
      html += '<div class="ccs-sec"><p class="ccs-h">Népszerű keresések</p><div class="ccs-chips">' +
        CFG.popular.map((t) => '<button type="button" class="ccs-chip ccs-it" role="option" data-q="' + esc(t) + '">' + esc(t) + '</button>').join('') + '</div></div>';
    }
    if (CFG.menu.length) {
      html += '<div class="ccs-sec"><p class="ccs-h">Böngéssz kategóriák szerint</p><div class="ccs-chips">' +
        CFG.menu.map((m) => '<a class="ccs-chip ccs-it" role="option" href="' + esc(m.u) + '">' + esc(m.t) + '</a>').join('') + '</div></div>';
    }
    return html;
  }

  const skeleton = '<div class="ccs-sec"><p class="ccs-h">Keresés…</p><div class="ccs-prods">' + '<div class="ccs-sk"><i></i><div><span></span><span style="width:45%"></span></div></div>'.repeat(3) + '</div></div>';

  /* ------------------------------------------------------------ kereső-példány */
  function makeSearcher(input, out, opts) {
    opts = opts || {};
    let ctrl = null;
    let seq = 0;
    let active = -1;
    let lastQ = '';

    const items = () => $$('.ccs-it', out);
    function setActive(i) {
      const list = items();
      list.forEach((el) => el.classList.remove('is-active'));
      active = list.length ? (i + list.length) % list.length : -1;
      if (active >= 0) {
        const el = list[active];
        el.classList.add('is-active');
        el.scrollIntoView({ block: 'nearest' });
        input.setAttribute('aria-activedescendant', el.id || '');
      } else input.removeAttribute('aria-activedescendant');
    }
    function paint(html, animate) {
      out.innerHTML = html;
      items().forEach((el, i) => { el.id = (opts.prefix || 'ccs-o') + '-' + i; });
      if (animate) { out.classList.remove('ccs-pane-in'); void out.offsetWidth; out.classList.add('ccs-pane-in'); }
      active = -1;
      input.removeAttribute('aria-activedescendant');
      if (opts.onPaint) opts.onPaint();
    }
    function showIdle() {
      lastQ = '';
      if (ctrl) ctrl.abort();
      paint(suggestHtml(true), false);
      if (opts.onState) opts.onState('');
    }
    const run = debounce(() => {
      const q = input.value.trim();
      if (!q) { showIdle(); return; }
      if (q === lastQ) return;
      lastQ = q;
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      const my = ++seq;
      if (!out.querySelector('.ccs-prod')) paint(skeleton, false);
      if (opts.onState) opts.onState(q);
      Promise.all([api(q, ctrl.signal), loadCols()]).then(([res, idx]) => {
        if (my !== seq) return;
        paint(renderResults(res, matchCols(q, idx), q), true);
        if (opts.onResults) opts.onResults(q, res);
      }).catch((e) => {
        if (e && e.name === 'AbortError') return;
        paint('<div class="ccs-empty"><b>Most nem sikerült keresni</b>Próbáld újra, vagy <a href="' + SEARCH_URL + '?q=' + encodeURIComponent(q) + '">nézd meg az összes találatot</a>.</div>', false);
      });
    }, 150);

    function submit() {
      const q = input.value.trim();
      if (!q) return;
      recent.add(q);
      location.href = SEARCH_URL + '?type=product&q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
    }
    function fill(q) { input.value = q; input.dispatchEvent(new Event('input', { bubbles: true })); input.focus({ preventScroll: true }); }

    input.addEventListener('input', () => { run(); if (opts.onInput) opts.onInput(input.value); });
    input.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active < 0 ? -1 : active - 1); }
      else if (e.key === 'Enter') {
        e.preventDefault();
        const el = items()[active];
        if (el) el.click(); else submit();
      }
    });
    out.addEventListener('click', (e) => {
      const chip = e.target.closest('[data-q]');
      if (chip) { e.preventDefault(); fill(chip.getAttribute('data-q')); return; }
      if (e.target.closest('[data-clear-recent]')) { recent.clear(); showIdle(); return; }
      const a = e.target.closest('a[href]');
      if (a && input.value.trim()) recent.add(input.value);
    });
    return { run, showIdle, submit, fill, paint, get query() { return input.value.trim(); } };
  }

  /* ------------------------------------------------------------ keresőpanel (mobilon teljes képernyő, asztalon lebegő) */
  let root = null; let panel = null; let input = null; let body = null; let inner = null; let allLink = null; let clearBtn = null; let searcher = null; let lastFocus = null; let ro = null;

  function build() {
    root = document.createElement('div');
    root.className = 'ccs';
    root.innerHTML =
      '<div class="ccs-scrim"></div>' +
      '<div class="ccs-panel" role="dialog" aria-modal="true" aria-label="Keresés">' +
      '<form class="ccs-form" role="search" action="' + SEARCH_URL + '" method="get">' +
      '<span class="ccs-fic">' + IC_SEARCH + '</span>' +
      '<input class="ccs-input" type="text" name="ccs-q" role="combobox" aria-expanded="true" aria-controls="ccs-list" aria-autocomplete="list" autocomplete="off" autocapitalize="off" autocorrect="off" spellcheck="false" enterkeyhint="search" placeholder="' + esc(placeholder()) + '" aria-label="Keresés a shopban">' +
      '<button type="button" class="ccs-clear" aria-label="Törlés" hidden>' + IC_X + '</button>' +
      '<button type="button" class="ccs-x">Mégse</button>' +
      '</form>' +
      '<div class="ccs-body"><div class="ccs-inner" id="ccs-list" role="listbox"></div></div>' +
      '<div class="ccs-foot"><span class="ccs-hint"><kbd>↑</kbd> <kbd>↓</kbd> lépkedés · <kbd>Enter</kbd> keresés · <kbd>Esc</kbd> bezárás</span><a class="ccs-all" href="' + SEARCH_URL + '" hidden>Összes találat megtekintése</a></div>' +
      '</div>';
    document.body.appendChild(root);
    panel = $('.ccs-panel', root);
    input = $('.ccs-input', root);
    body = $('.ccs-body', root);
    inner = $('.ccs-inner', root);
    allLink = $('.ccs-all', root);
    clearBtn = $('.ccs-clear', root);
    searcher = makeSearcher(input, inner, {
      prefix: 'ccs-o',
      onState: (q) => {
        clearBtn.hidden = !q && !input.value;
        allLink.hidden = !q;
        if (q) allLink.href = SEARCH_URL + '?type=product&q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
      },
      onInput: (v) => { clearBtn.hidden = !v; if (!v.trim()) allLink.hidden = true; },
      onPaint: measure
    });
    $('.ccs-form', root).addEventListener('submit', (e) => { e.preventDefault(); searcher.submit(); });
    $('.ccs-scrim', root).addEventListener('click', close);
    $('.ccs-x', root).addEventListener('click', close);
    clearBtn.addEventListener('click', () => { input.value = ''; clearBtn.hidden = true; searcher.showIdle(); input.focus(); });
    allLink.addEventListener('click', () => recent.add(input.value));
    // mobilon a találatok görgetése leengedi a billentyűzetet (mint a natív kereső), így több találat látszik
    body.addEventListener('touchmove', () => { if (root.classList.contains('is-kb') && document.activeElement === input) input.blur(); }, { passive: true });
    ro = new ResizeObserver(measure);
    ro.observe(inner);
    // Tab-csapda
    panel.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab') return;
      const f = $$('input, button:not([hidden]), a[href]', panel).filter((n) => n.offsetParent !== null);
      if (!f.length) return;
      const first = f[0]; const last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  function measure() {
    if (!root || !mqDesk.matches) { if (body) body.style.removeProperty('--ccs-h'); return; }
    body.style.setProperty('--ccs-h', Math.ceil(inner.offsetHeight) + 'px');
  }

  function headerBottom() {
    const h = $('.js-section-header header') || $('header.header') || $('header');
    if (!h) return 84;
    const r = h.getBoundingClientRect();
    return Math.max(64, Math.min(140, Math.round(r.bottom + 10)));
  }

  // a mobil menüfiók azonnali zárása (animáció nélkül – a kereső úgyis teljesen eltakarja)
  function closeSheetNow() {
    if (!document.documentElement.classList.contains('cc-mm-lock')) return;
    const moving = [$('.cc-mm-sheet[data-cc-ready]'), $('.cc-mm-scrim[data-cc-ready]')].filter(Boolean);
    moving.forEach((n) => n.classList.add('is-drag'));
    const c = $('[data-cc-close]');
    if (c) c.click();
    requestAnimationFrame(() => requestAnimationFrame(() => moving.forEach((n) => n.classList.remove('is-drag'))));
  }

  function open(prefill, kbd) {
    if (!root) build();
    root.classList.toggle('is-kbd', !!kbd);
    if (root.classList.contains('is-open')) { input.focus(); return; }
    // előbb a menü fiókja zárul (a fókusz a menügombra kerül), így bezáráskor oda tér vissza
    closeSheetNow();
    lastFocus = document.activeElement;
    root.style.setProperty('--ccs-top', headerBottom() + 'px');
    input.placeholder = placeholder();
    root.classList.add('is-open');
    document.documentElement.classList.add('ccs-lock');
    fitViewport();
    // szinkron fókusz még a koppintás eseményén belül – késleltetve iOS-en nem jön fel a billentyűzet
    input.focus({ preventScroll: true });
    if (typeof prefill === 'string' && prefill) { input.value = prefill; clearBtn.hidden = false; }
    if (input.value.trim()) { searcher.run(); } else searcher.showIdle();
    loadCols();
    setTimeout(() => { input.focus({ preventScroll: true }); input.select(); measure(); }, 60);
  }
  function close(kbd) {
    if (!root || !root.classList.contains('is-open')) return;
    root.classList.toggle('is-kbd', !!kbd);
    root.classList.remove('is-open');
    document.documentElement.classList.remove('ccs-lock');
    fitViewport();
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  const isOpen = () => !!(root && root.classList.contains('is-open'));

  /* ------------------------------------------------------------ mobil: a panel a látható viewporthoz igazodik */
  // Android Chrome-on a billentyűzet alapból csak a vizuális viewportot szűkíti: egy inset:0 panel alja
  // (és vele a találatok) a billentyűzet mögé kerülne. A visualViewport méretére állítva a panel pontosan fölötte ér véget.
  const vv = window.visualViewport;
  function fitViewport() {
    if (!root) return;
    if (!vv || mqDesk.matches || !isOpen()) {
      root.style.removeProperty('--ccs-vh');
      root.style.removeProperty('--ccs-vt');
      root.classList.remove('is-kb');
      return;
    }
    if (vv.scale > 1.01) return; // csípő-nagyításnál nem követjük
    root.style.setProperty('--ccs-vh', Math.round(vv.height) + 'px');
    root.style.setProperty('--ccs-vt', Math.round(vv.offsetTop) + 'px');
    root.classList.toggle('is-kb', window.innerHeight - vv.height > 120);
  }
  if (vv) { vv.addEventListener('resize', fitViewport); vv.addEventListener('scroll', fitViewport); }

  /* ------------------------------------------------------------ belépési pontok */
  // a fejléc keresőikonja (a téma / külső app keresője helyett) – capture fázisban, hogy elsőként fusson
  function isTrigger(t) {
    return t.closest('.js-search-open-trigger, a[href="/search"], a[href^="/search?"], [data-ccs-open], .ccs-navbtn') && !t.closest('.ccs');
  }
  const onTrigger = (e) => {
    const t = e.target && e.target.closest ? e.target : null;
    if (!t || !isTrigger(t)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
  };
  window.addEventListener('click', onTrigger, true);
  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isOpen()) { e.preventDefault(); close(true); return; }
    const typing = /^(input|textarea|select)$/i.test((document.activeElement || {}).tagName || '') || (document.activeElement && document.activeElement.isContentEditable);
    if (!typing && (e.key === '/' || ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k'))) { e.preventDefault(); open('', true); }
  }, true);
  window.addEventListener('resize', () => { if (isOpen()) { root.style.setProperty('--ccs-top', headerBottom() + 'px'); input.placeholder = placeholder(); measure(); fitViewport(); } });

  /* ------------------------------------------------------------ keresés a menüben */
  function mountMenu() {
    // mobil fiók: mezőnek látszó gomb – koppintásra a teljes képernyős kereső nyílik, a billentyűzet ott jön fel.
    // (A fiókba ágyazott valódi mező hibás volt: a billentyűzet a fiók alsó felét és a találatokat eltakarta.)
    const sheet = $('.cc-mm-sheet[data-cc-ready]');
    if (sheet && !sheet.hasAttribute('data-ccs-mounted')) {
      const btn = $('[data-cc-search]', sheet);
      if (btn) {
        sheet.setAttribute('data-ccs-mounted', '');
        const fake = document.createElement('button');
        fake.type = 'button';
        fake.className = 'ccs-mmsearch';
        fake.setAttribute('data-ccs-open', '');
        fake.setAttribute('aria-haspopup', 'dialog');
        fake.innerHTML = IC_SEARCH + '<span>' + esc(CFG.placeholder_m || CFG.placeholder) + '</span>';
        btn.replaceWith(fake);
        // 2026-10-16 gyorsítás: a kollekciólista csak a kereső megnyitásakor töltődik (open → loadCols), nem minden oldalon
      }
    }
    // asztali menüsor: „Keresés” gomb az utolsó elemként
    $$('.cc-mm-bar').forEach((bar) => {
      if ($('.ccs-navli', bar)) return;
      const li = document.createElement('li');
      li.className = 'ccs-navli';
      li.innerHTML = '<button type="button" class="cc-mm-trig ccs-navbtn" aria-haspopup="dialog" aria-label="Keresés" title="Keresés (/)">' + IC_SEARCH + '<span>Keresés</span></button>';
      bar.appendChild(li);
      setTimeout(() => window.dispatchEvent(new Event('resize')), 30);
    });
  }
  mountMenu();
  const mo = new MutationObserver(debounce(mountMenu, 80));
  const startObs = () => mo.observe(document.body, { childList: true, subtree: true });
  if (document.body) startObs(); else document.addEventListener('DOMContentLoaded', startObs);
  document.addEventListener('DOMContentLoaded', () => { mountMenu(); setTimeout(mountMenu, 400); });
  document.addEventListener('shopify:section:load', () => setTimeout(mountMenu, 100));

  /* ------------------------------------------------------------ előtöltés (gyors oldalváltás) */
  // Chrome/Edge a speculationrules-t használja; máshol egyszerű <link rel="prefetch"> hover/érintés alapján
  if (!(HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules'))) {
    const done = new Set();
    const pre = (a) => {
      if (!a || !a.href || a.origin !== location.origin || a.target === '_blank' || done.has(a.href)) return;
      if (/\/(cart|checkout|account|customer)/.test(a.pathname) || a.hash && a.pathname === location.pathname) return;
      done.add(a.href);
      const l = document.createElement('link');
      l.rel = 'prefetch';
      l.href = a.href;
      document.head.appendChild(l);
    };
    let t;
    document.addEventListener('pointerover', (e) => { const a = e.target.closest && e.target.closest('a[href]'); if (!a || e.pointerType !== 'mouse') return; clearTimeout(t); t = setTimeout(() => pre(a), 90); }, { passive: true });
    document.addEventListener('touchstart', (e) => { const a = e.target.closest && e.target.closest('a[href]'); pre(a); }, { passive: true });
  }

  /* ------------------------------------------------------------ oldalváltás: azonnali visszajelzés */
  (() => {
    const html = document.documentElement;
    let bar = null;
    const start = () => {
      if (!bar) { bar = document.createElement('div'); bar.id = 'cc-progress'; bar.setAttribute('aria-hidden', 'true'); document.body.appendChild(bar); }
      void bar.offsetWidth;
      html.classList.add('cc-navigating');
    };
    document.addEventListener('click', (e) => {
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const a = e.target.closest && e.target.closest('a[href]');
      if (!a || a.target === '_blank' || a.hasAttribute('download') || a.origin !== location.origin) return;
      const raw = a.getAttribute('href') || '';
      if (/^(#|javascript:)/.test(raw) || (a.pathname === location.pathname && a.search === location.search)) return;
      setTimeout(() => { if (!e.defaultPrevented) start(); }, 0);
    }, false);
    window.addEventListener('pageshow', (e) => { if (e.persisted) html.classList.remove('cc-navigating'); });
  })();

  /* ------------------------------------------------------------ védőháló: ha a szűrősáv nem épül fel, a téma szűrője újra látszik */
  (() => {
    const html = document.documentElement;
    const guard = () => {
      if (!$('.js-collection-products')) return;
      if (!$('#mainCollectionProductFiltersForm')) { html.classList.add('ccf-off'); return; }
      let n = 0;
      const t = setInterval(() => {
        if (html.classList.contains('ccf-on')) { clearInterval(t); return; }
        if (++n >= 25) { clearInterval(t); html.classList.add('ccf-off'); }
      }, 200);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', guard); else guard();
  })();

  window.ccSearch = { open, close };
})();
